<div class="slider-container">
    <div #markersContainer class="markers-container"></div>
    <input #rangeInput
           [ngClass]="{
            'brixx-input': !isBusinessDoctors,
            'business-doctors-input': isBusinessDoctors
           }"
           type="range"
           min="0"
           [max]="brixxSinglePlansCountItems.length - 1"
           step="1"
           [(ngModel)]="value"
           (input)="onInputChange($event)"
           attr.data-testid="{{testId}}RangeSlider"
           class="slider" />
</div>